import React from 'react';
import {getLangCode, stringBundle} from '../stringBundle';
import {Loader} from '../components/widgets/Loader';

const localizedStringBundle = stringBundle(getLangCode());

const Loading = (isMobileLogin) => {

  if (isMobileLogin) {
    return <Loader/>
  }

  return (
    <div>
      <div className="appContent loading-content">
        <div className="card page-card loading-card">
          <div className="loading-msg">{localizedStringBundle.LOADING_MSG}</div>
          <div className="wrapper-lg">
            <Loader/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;


// WEBPACK FOOTER //
// ./src/containers/Loading.js